// src/pages/PwaLoginHandler.tsx
import React, { useContext, useEffect } from 'react';
import { AuthContext } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import tokenService, { TokenFromUrlResult } from '../utils/tokenService';
import { CenteredPage, Heading, Spinner } from '../components/ui';

const readTokenErrorMessage = (result: TokenFromUrlResult): string => {
  if (result === 'expired') {
    return 'Ce lien de connexion a expiré.';
  }

  if (result === 'used') {
    return 'Ce lien de connexion a déjà été utilisé.';
  }

  return 'Lien de connexion invalide.';
};

const PwaLoginHandler: React.FC = () => {
  const auth = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    tokenService.handleTokenFromUrl()
      .then((result) => {
        if (result === 'invalid' || result === 'expired' || result === 'used') {
          const message = readTokenErrorMessage(result);
          navigate(`/error?message=${encodeURIComponent(message)}`, { state: { message } });
          return;
        }
        navigate('/');
      })
      .catch((error: any) => {
        console.error("PwaLoginHandler: Error while handling URL token:", error);
        const message = "Erreur lors de la sauvegarde du token.";
        navigate(`/error?message=${encodeURIComponent(message)}`, { state: { message } });
      });
  }, [navigate]);

  if (auth?.loading) {
    return (
      <CenteredPage constrained style={{ height: '100vh' }}>
        <Heading as="h1" marginBottom={3} visualLevel="h3">Vérification de la session...</Heading>
        <Spinner label="Vérification..." />
      </CenteredPage>
    );
  }

  // This component will now primarily handle the redirection, so the existing UI for
  // "Session introuvable" or "Prêt à vous connecter" might not be reached or needed
  // in the same way. However, keeping a fallback for cases where useEffect hasn't
  // redirected yet or if there's an issue.
  return (
    <CenteredPage constrained style={{ height: '100vh' }}>
      <Heading as="h1" marginBottom={3} visualLevel="h3">Traitement de la connexion PWA...</Heading>
      <Spinner label="Chargement..." />
    </CenteredPage>
  );
};

export default PwaLoginHandler;
